// extracted by mini-css-extract-plugin
module.exports =  {"select":"fuoA2j76nRRRVO_0FyRR"};